import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import Dropdown from '../../node_modules/reactstrap/esm/Dropdown.js';
import DropdownToggle from '../../node_modules/reactstrap/esm/DropdownToggle.js';
import styled from 'styled-components';
import { darkerLtGrey, lightBlue } from '../../assets/colors.js';
import { Montserrat } from '../../assets/fonts.js';
import getPgaTld from '../../getPgaTld.js';
import { UserIcon } from '../Icons/index.js';
import { DropDown } from '../MemberDropdown/pieces.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var StyledDropdown = styled(Dropdown)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  button {\n    display: flex;\n    :hover {\n      background-color: ", ";\n    }\n  }\n"])), darkerLtGrey);
var StyledDropdownToggle = styled(DropdownToggle)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  min-width: 160px;\n  min-height: 82px;\n  background-color: ", " !important;\n  border: 0;\n  :hover {\n    text-decoration: none;\n  }\n"])), lightBlue);
var StyledText = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-family: ", ";\n  color: #ffffff;\n  align-self: center;\n  font-size: 11px;\n  text-transform: uppercase;\n  cursor: pointer;\n  text-decoration: none;\n"])), Montserrat);
var MyAccountIcon = styled(UserIcon)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  svg path {\n    stroke: #ffffff;\n    stroke-width: 1.5;\n  }\n"])));
var pgaTld = getPgaTld();
var options = [{
  id: 1,
  to: "https://account.".concat(pgaTld, "/signup"),
  label: "Create Account"
}, {
  id: 2,
  to: "https://account.".concat(pgaTld, "/login?return_to=https://account.").concat(pgaTld),
  label: "Login"
}];
var index = (function () {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    dropdownOpen = _useState2[0],
    setDropdownOpen = _useState2[1];
  var toggle = function toggle() {
    return setDropdownOpen(function (prevState) {
      return !prevState;
    });
  };
  return /*#__PURE__*/React__default.createElement(StyledDropdown, {
    isOpen: dropdownOpen,
    toggle: toggle
  }, /*#__PURE__*/React__default.createElement(StyledDropdownToggle, null, /*#__PURE__*/React__default.createElement(MyAccountIcon, null), /*#__PURE__*/React__default.createElement(StyledText, null, "My Account")), /*#__PURE__*/React__default.createElement(DropDown, {
    options: options,
    publicDropdown: true
  }));
});

export { StyledDropdown, index as default };
